import { render } from "./Requests.vue?vue&type=template&id=79990cba&ts=true"
import script from "./Requests.vue?vue&type=script&lang=ts"
export * from "./Requests.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__